import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Container, Typography } from '@mui/material';
import Hero from '../../sections/Hero';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy</title>
        <meta
          name="description"
          content="JBR Delivery LLC privacy policy. Learn how we collect, use, and protect your personal information."
        />
      </Helmet>

      <Hero 
        title="Privacy Policy"
        subtitle="How we collect, use, and protect your information"
        backgroundImage="/assets/images/legal-bg.jpg"
        showPhone={false}
      />

      <Box component="section" py={8}>
        <Container maxWidth="md">
          <Typography variant="h2" component="h2" gutterBottom>
            Our Privacy Policy
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ mb: 4 }}>
            Last Updated: March 15, 2025
          </Typography>
          
          <Typography variant="h5" component="h3" gutterBottom sx={{ mt: 4 }}>
            1. Introduction
          </Typography>
          <Typography variant="body1" paragraph>
            JBR Delivery LLC ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
          </Typography>
          
          <Typography variant="h5" component="h3" gutterBottom sx={{ mt: 4 }}>
            2. Information We Collect
          </Typography>
          <Typography variant="body1" paragraph>
            We may collect information about you in various ways, including:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 4 }}>
            <li>Personal Information: Name, email address, phone number, and address when you request a quote or contact us</li>
            <li>Transaction Information: Service details, payment information, and service history</li>
            <li>Device Information: IP address, browser type, and operating system</li>
            <li>Usage Information: How you interact with our website and services</li>
          </Typography>
          
          <Typography variant="h5" component="h3" gutterBottom sx={{ mt: 4 }}>
            3. How We Use Your Information
          </Typography>
          <Typography variant="body1" paragraph>
            We may use the information we collect about you to:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 4 }}>
            <li>Provide, maintain, and improve our services</li>
            <li>Process transactions and send related information</li>
            <li>Respond to comments, questions, and requests</li>
            <li>Send you technical notices, updates, security alerts, and support messages</li>
            <li>Communicate with you about services, offers, promotions, and events</li>
          </Typography>
          
          <Typography variant="h5" component="h3" gutterBottom sx={{ mt: 4 }}>
            4. Sharing of Information
          </Typography>
          <Typography variant="body1" paragraph>
            We may share your information with:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 4 }}>
            <li>Service providers who perform services on our behalf</li>
            <li>Professional advisors, such as lawyers, auditors, and insurers</li>
            <li>Government entities when required by law</li>
          </Typography>
          
          <Typography variant="h5" component="h3" gutterBottom sx={{ mt: 4 }}>
            5. Security
          </Typography>
          <Typography variant="body1" paragraph>
            We implement reasonable measures to help protect your personal information from loss, theft, misuse, and unauthorized access.
          </Typography>
          
          <Typography variant="h5" component="h3" gutterBottom sx={{ mt: 4 }}>
            6. Your Choices
          </Typography>
          <Typography variant="body1" paragraph>
            You may opt out of receiving promotional communications from us by following the instructions in those messages. You may also request access to, correction of, or deletion of your personal information by contacting us.
          </Typography>
          
          <Typography variant="h5" component="h3" gutterBottom sx={{ mt: 4 }}>
            7. Changes to this Privacy Policy
          </Typography>
          <Typography variant="body1" paragraph>
            We may update this Privacy Policy from time to time. If we make material changes, we will notify you as required by law.
          </Typography>
          
          <Typography variant="h5" component="h3" gutterBottom sx={{ mt: 4 }}>
            8. Contact Us
          </Typography>
          <Typography variant="body1" paragraph>
            If you have questions about this Privacy Policy, please contact us at jbrdeliveryllc@gmail.com or (920) 255-8952.
          </Typography>
        </Container>
      </Box>
    </>
  );
};

export default PrivacyPolicyPage;
